import React from "react";

import { SearchspringFetcher } from "@app/lib/searchspring";
import { useSearchspringContext } from "@app/providers/searchspring";

import { useSearchspringOption } from "./use-searchspring-option";

type Options = {
  syncWithURL?: boolean;
};

export function useSearchspringFilters<Client extends SearchspringFetcher<Response>, Response>(options: Options = {}) {
  const { syncWithURL = true } = options;
  const { refine } = useSearchspringContext<Client, Response>();

  const activeFilters = useSearchspringOption("filters", {
    defaultValue: new Set<string>(),
    syncWithURL,
  });

  const handleToggleFilter = (filter: string) => {
    const filters = new Set(activeFilters);
    const targetFilters = filter.split(",");

    targetFilters.forEach((target) => {
      if (filters.has(target)) filters.delete(target);
      else filters.add(target);
    });

    refine("filters", filters);
    // refine("page", 1);
  };

  const handleRemoveAllByField = (field: string) => {
    const filters = new Set(activeFilters);
    const filtersToRemove = Array.from(filters).filter((filter) => filter.includes(field));
    filtersToRemove.forEach((filter) => filters.delete(filter));

    refine("filters", filters);
    // refine("page", 1);
  };

  const handleRemoveFilter = (filter: string) => {
    const filters = new Set(activeFilters);
    if (filters.has(filter)) filters.delete(filter);

    refine("filters", filters);
    // refine("page", 1);
  };

  const handleClearFilters = () => {
    refine("filters", new Set([]));
    // refine("page", 1);
  };

  return {
    activeFilters,
    handleToggleFilter,
    handleRemoveFilter,
    handleClearFilters,
    handleRemoveAllByField,
  };
}
